import { ChangeEvent } from 'react';
import { i18nService } from '../../AppSettings/services/i18nService';
import type { SearchType, ActiveTab } from '../../types/team';

interface TeamSearchBarProps {
  globalSearchTerm: string;
  onSearchTermChange: (term: string) => void;
  searchType: SearchType;
  onSearchTypeChange: (type: SearchType) => void;
  activeTab: ActiveTab;
  onTabChange: (tab: ActiveTab) => void;
  employeesCount: number;
  contactsCount: number;
  onOpenRatesModal: () => void;
  showCompanyRatesButton?: boolean;
}

const TeamSearchBar = ({
  globalSearchTerm,
  onSearchTermChange,
  searchType,
  onSearchTypeChange,
  activeTab,
  onTabChange,
  employeesCount,
  contactsCount,
  onOpenRatesModal,
  showCompanyRatesButton = true,
}: TeamSearchBarProps): JSX.Element => {
  return (
    <div className="team-invite-bar team-global-search">
      <div className="team-invite-input-section">
        <input
          className="team-invite-input"
          type="text"
          placeholder={i18nService.t('team.search.placeholder.allTables')}
          value={globalSearchTerm}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            onSearchTermChange(e.target.value)
          }
        />
        <select
          className="team-invite-type-select"
          value={searchType}
          onChange={(e: ChangeEvent<HTMLSelectElement>) =>
            onSearchTypeChange(e.target.value as SearchType)
          }
        >
          <option value="all">
            {i18nService.t('team.search.inviteFilters.allFields')}
          </option>
          <option value="name">
            {i18nService.t('team.search.inviteFilters.name')}
          </option>
          <option value="email">
            {i18nService.t('team.search.inviteFilters.email')}
          </option>
          <option value="phone">
            {i18nService.t('team.search.inviteFilters.phone')}
          </option>
          <option value="id">
            {i18nService.t('team.search.inviteFilters.id')}
          </option>
          <option value="company">
            {i18nService.t('team.search.inviteFilters.company')}
          </option>
        </select>
      </div>
      <div className="team-invite-options">
        <div className="team-count-badges">
          <span
            className={`team-count-badge ${activeTab === 'team' ? 'active' : ''}`}
            onClick={() => onTabChange('team')}
          >
            <span className="team-count-label">
              {i18nService.t('team.search.inviteCount.team')}
            </span>
            <span className="team-count-number">{employeesCount}</span>
          </span>
          <span
            className={`team-count-badge ${activeTab === 'contacts' ? 'active' : ''}`}
            onClick={() => onTabChange('contacts')}
          >
            <span className="team-count-label">
              {i18nService.t('team.search.inviteCount.contacts')}
            </span>
            <span className="team-count-number">{contactsCount}</span>
          </span>
        </div>
        {showCompanyRatesButton && (
          <button className="team-rates-button" onClick={onOpenRatesModal}>
            Company Rates
          </button>
        )}
      </div>
    </div>
  );
};

export default TeamSearchBar;
